/**
 * Feature #178802: human-readable labels for Wine eligibility market tokens.
 *
 * The Wine request stores eligibility markets as raw enum tokens
 * (DestinationMarket) in `consignment.items[].product.declarations[].market`,
 * e.g. "EU", "BRAZIL". These are indexed as-is in `product_eligibility_countries`.
 *
 * This map provides the equivalent display label, indexed separately in
 * `product_eligibility_country_labels`, so users can search by either the raw
 * code or the label (e.g. "European Union").
 *
 * NOTE: These labels intentionally match the DFE frontend `WinemakingMarketLabels`
 * (EU -> "European Union", NOT_APPLICABLE -> "General"), NOT the Salesforce
 * `SfWineMarket` text (which uses EU -> "EU").
 */
const ELIGIBILITY_MARKET_LABELS: Readonly<Record<string, string>> = {
  NOT_APPLICABLE: "General",
  EU: "European Union",
  BRAZIL: "Brazil",
  GREAT_BRITAIN: "Great Britain",
}

/**
 * Map a raw eligibility market token to its display label.
 * Returns the original token unchanged when no label mapping exists, so
 * additional markets remain searchable even before a label is added here.
 */
export const toEligibilityMarketLabel = (market: string): string =>
  ELIGIBILITY_MARKET_LABELS[market] ?? market
